import { useState } from "react";

const ProcessSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const totalSlides = 3;

  const handleNext = () => {
    if (activeIndex < totalSlides - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  const handlePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  return (
    <div className="process-slider-wrapper">
      <div className="process-slider">
        <div
          className="slider-track"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          <div className="row mx-0 st-col-wrap one">
            <div className="col-lg-4">
              <div className="st-process-cards one">
                <h6>Market Research and Analysis</h6>
                <p>
                  Before diving into stock trading app development, conduct
                  thorough market research. Understand the target audience,
                  identify competitors, and analyze market trends to build a
                  competitive product.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="st-process-cards two">
                <h6>Define Features and Functionality</h6>
                <p>
                  List all the features your app will include. Stock trading app
                  development should align with user needs, ensuring a robust
                  and feature-rich platform.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="st-process-cards three">
                <h6>Design the User Interface (UI)</h6>
                <p>
                  A clean and attractive UI is essential. During the stock
                  trading app development phase, focus on creating designs that
                  are both visually appealing and functional.
                </p>
              </div>
            </div>
          </div>

          <div className="row mx-0 st-col-wrap two">
            <div className="col-lg-4">
              <div className="st-process-cards col-one">
                <h6>Backend Development</h6>
                <p>
                  The backend is the engine of your app. Stock trading app
                  development involves building a secure and scalable backend
                  that supports high-speed transactions and data processing.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="st-process-cards col-two">
                <h6>Frontend Development</h6>
                <p>
                  Frontend development ensures users can interact seamlessly
                  with the app. Stock trading app development incorporates
                  responsive design for smooth user experiences.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="st-process-cards col-three">
                <h6> Integration of APIs</h6>
                <p>
                  Stock trading app development relies on APIs for accessing
                  real-time stock market data, payment gateways, and other
                  essential services.
                </p>
              </div>
            </div>
          </div>

          <div className="row mx-0 st-col-wrap three">
            <div className="col-lg-4">
              <div className="st-process-cards col-three-one">
                <h6> Integration of APIs</h6>
                <p>
                  Stock trading app development relies on APIs for accessing
                  real-time stock market data, payment gateways, and other
                  essential services.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="st-process-cards col-three-two">
                <h6>Testing and Quality Assurance</h6>
                <p>
                  Rigorous testing is crucial to ensure the app functions as
                  intended. Stock trading app development includes performance
                  testing, security checks, and bug fixing.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="st-process-cards col-three-three">
                <h6>Launch and Marketing</h6>
                <p>
                  Once the stock trading app is ready, launch it. Effective
                  marketing strategies are vital to promote your stock trading
                  app development project and attract users.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="slider-controls">
        <button
          className={`why-custom-prev-arrow st-key-left-btn ${
            activeIndex === 0 ? "disabled" : ""
          }`}
          style={{
            color: activeIndex === 0 ? "#8C8D8D" : "#fff",
            cursor: activeIndex === 0 ? "not-allowed" : "pointer",
            backgroundColor: "#24272899",
          }}
          onClick={handlePrev}
          disabled={activeIndex === 0}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </button>
        <button
          className={`why-custom-next-arrow st-key-right-btn ${
            activeIndex === totalSlides - 1 ? "disabled" : ""
          }`}
          style={{
            color: activeIndex === totalSlides - 1 ? "#8C8D8D" : "#fff",
            cursor: activeIndex === totalSlides - 1 ? "not-allowed" : "pointer",
            backgroundColor: "#24272899",
          }}
          onClick={handleNext}
          disabled={activeIndex === totalSlides - 1}
        >
          <i className="fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </div>
  );
};

export default ProcessSlider;
